import { getLocaleFromCountry } from '@sportninja/common/currency'
import type { Country } from '@sportninja/common/types/Country'

export const formatRegistrationMoney = (
  amount: number,
  country?: Country
): string =>
  new Intl.NumberFormat(getLocaleFromCountry(country), {
    style: 'currency',
    currency: country?.currency_code || 'USD',
  }).format(Number(amount) || 0)
